import { Component, Input, OnInit } from '@angular/core';
import { TenantConfService } from 'src/app/services/tenant-conf.service';

@Component({
  selector: 'app-promo-card',
  templateUrl: './promo-card.component.html',
  styleUrls: ['./promo-card.component.scss'],
})
export class PromoCardComponent implements OnInit {
  @Input() promo;

  language: any;
  dateFormat = 'd/M/yy';

  constructor(private tenantService: TenantConfService) {
    this.language = this.tenantService.getLanguage();
  }

  ngOnInit() {    
    if (this.language === 'EN') {
      this.dateFormat = 'M/d/yy';
    }
  }
}
